import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Allow token-based auth as fallback (for environments where cookies blocked)
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("session_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("session_token");
  }
};

const stored = localStorage.getItem("session_token");
if (stored) {
  api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

// Admin JWT (standalone admin login). Loaded on app start; cleared on adminLogout().
const adminToken = localStorage.getItem("admin_jwt");
if (adminToken) {
  api.defaults.headers.common["X-Admin-Token"] = adminToken;
}

export const setAdminToken = (token) => {
  if (token) {
    api.defaults.headers.common["X-Admin-Token"] = token;
    localStorage.setItem("admin_jwt", token);
  } else {
    delete api.defaults.headers.common["X-Admin-Token"];
    localStorage.removeItem("admin_jwt");
  }
};

export const adminLogin = async ({ username, password }) => {
  const { data } = await api.post("/admin/auth/login", { username, password });
  if (data.token) setAdminToken(data.token);
  return data;
};

export const adminLogout = async () => {
  try { await api.post("/admin/auth/logout"); } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("[adminLogout]", e?.message);
  }
  setAdminToken(null);
};

export const adminMe = async () => {
  const { data } = await api.get("/admin/auth/me");
  return data;
};

export default api;
